import ExcelJS from 'exceljs';

export const exportExcelLayout = async (format = 'xlsx') => {
  const headers = [
    'Servicio', 'Viaje', 'Origen', 'Destino',
    'Tipo Servicio', 'Dia Cita', 'Hora Cita',
    'Operador', 'Unidad', 'Proveedor',
  ];

  // XLSX export
  if (format === 'xlsx') {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Citas');

    worksheet.addRow(headers);

    // Header style
    const headerRow = worksheet.getRow(1);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '000000' },
      };
      cell.alignment = { horizontal: 'center' };
      cell.border = {
        top: { style: 'thin' },
        bottom: { style: 'thin' },
        left: { style: 'thin' },
        right: { style: 'thin' },
      };
    });

    // Add 20 empty rows
    for (let i = 0; i < 20; i++) {
      const row = worksheet.addRow(new Array(headers.length).fill(''));
      row.eachCell((cell) => {
        cell.border = {
          top: { style: 'thin' },
          bottom: { style: 'thin' },
          left: { style: 'thin' },
          right: { style: 'thin' },
        };
      });
    }

    worksheet.columns.forEach((col) => (col.width = 15));

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = 'Citas.xlsx';
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  }

  // CSV export
  if (format === 'csv') {
    let csvContent = headers.join(',') + '\n';

    // Add 20 empty rows
    for (let i = 0; i < 20; i++) {
      csvContent += ','.repeat(headers.length - 1) + '\n';
    }

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = 'Citas.csv';
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  }
};